export default __webpack_public_path__ + "static/media/woman_in_front_of_pepper.5aedfbbb.png";